/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import DialogOutputDTO, { MAP_OUTPUT_FROM_WATSON } from '../../../dto/DialogOutputDTO';
import Accordion, { AccordionItem } from '../../@base/Accordion';
import Button from '../../@base/Button';
import Input from '../../@base/Input';
import TextArea from '../../@base/TextArea';
import ContextMenu from '../../ContextMenu/ContextMenu';
import DeleteConfirmation from '../../DeleteConfirmation/DeleteConfirmation';
import styles from './DialogNode.module.css';

const elementOptionList = {
  label: '',
  value: '',
};

const isValidElementOptionList = (element) => {
  if (!element.label
    || !element.value
    || element.label.trim() === ''
    || element.value.trim() === '') {
    return false;
  }
  return true;
};

const DialogNodeOutputOptionList = (props) => {
  const [optionList, setOptionList] = useState(props.output);

  const onChangeHandler = (e, key, index = null) => {
    const { value } = e.target;
    const optionListChanged = { ...optionList };
    if (optionListChanged.elements) {
      optionListChanged.elements = JSON.parse(JSON.stringify(optionList.elements));
    }
    if (index !== null) {
      optionListChanged.elements[index][key] = value;
    } else {
      optionListChanged[key] = value;
    }
    setOptionList(optionListChanged);
  };

  const onBlurHandler = (elementIndex = null) => {
    if (elementIndex !== null) {
      const element = optionList.elements[elementIndex];
      if (!isValidElementOptionList(element)) return false;
    }
    const optionListToUpdate = {
      ...optionList,
      elements: optionList.elements.filter((v) => isValidElementOptionList(v)),
    };
    props.updateOutput(optionListToUpdate);
  };

  const onDeleteHandler = (index) => {
    const optionListToUpdate = {
      ...optionList,
      elements: optionList.elements.filter((v, i) => i !== index && isValidElementOptionList(v)),
    };
    props.updateOutput(optionListToUpdate);
  };

  const originalElementLenght = props.output.elements ? props.output.elements.length : 0;

  useEffect(() => {
    if (props.output) {
      let { elements } = props.output;
      elements = elements ? elements.concat({ ...elementOptionList }) : [{ ...elementOptionList }];
      setOptionList({
        ...props.output,
        elements,
      });
    }
  }, [props.output]);

  return (
    <div className="item-list option">
      <Input
        value={optionList.title}
        onChange={(e) => onChangeHandler(e, 'title')}
        onBlur={() => onBlurHandler()}
        label="Título:"
        inline
        labelWidth={70}
        width={450}
        placeholder="Escreva o título da lista de opções"
      />
      <Input
        value={optionList.description}
        onChange={(e) => onChangeHandler(e, 'description')}
        onBlur={() => onBlurHandler()}
        label="Descrição:"
        inline
        labelWidth={70}
        width={450}
        placeholder="Escreva a descrição da lista de opções"
      />
      <div>Opções:</div>
      <div className="options-list">
        <div>
          <div />
          <div>Rótulo:</div>
          <div>Valor:</div>
          <div />
        </div>
        {optionList.elements && optionList.elements.map((el, i) => (
          <div key={i}>
            <div>{i < originalElementLenght && i + 1}</div>
            <div>
              <Input
                value={el.label}
                onChange={(e) => onChangeHandler(e, 'label', i)}
                onBlur={() => onBlurHandler(i)}
                placeholder={`Digite rótulo da ${i !== 0 && 'nova '}opção`}
              />
            </div>
            <div>
              <Input
                value={el.value}
                onChange={(e) => onChangeHandler(e, 'value', i)}
                onBlur={() => onBlurHandler(i)}
                placeholder={`Digite valor da ${i !== 0 && 'nova '}opção`}
              />
            </div>
            <div>
              {i < originalElementLenght
                && (
                  <Button
                    small
                    circle
                    title="Apagar opção"
                    onClick={() => onDeleteHandler(i)}
                  >
                    <span>
                      <i className="fa fa-times" aria-hidden="true" />
                    </span>
                  </Button>
                )}
            </div>
          </div>
        ))}

      </div>
      <div />
    </div>
  );
};

const DialogNodeOutputText = (props) => {
  const [text, setText] = useState(props.output);
  const onChangeHandler = (e, index) => {
    const { value } = e.target;
    const valuesChanged = [...text.values];
    valuesChanged[index] = value;
    setText({
      ...text,
      values: valuesChanged,
    });
  };

  const onBlurHandler = () => {
    const textToUpdate = {
      ...text,
      values: text.values.filter((v) => v.trim() !== ''),
    };
    props.updateOutput(textToUpdate);
  };

  const onDeleteHandler = (index) => {
    const textToUpdate = {
      ...text,
      values: text.values.filter((v, i) => i !== index && v.trim() !== ''),
    };
    props.updateOutput(textToUpdate);
  };

  useEffect(() => {
    if (props.output) {
      let { values } = props.output;
      values = values ? values.concat('') : [''];
      setText({
        ...props.output,
        values,
      });
    }
  }, [props.output]);

  return (
    <>
      {text.values.map((value, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="item-list" key={index}>
          <div style={{ width: '100%' }}>
            <TextArea
              placeholder={index === 0 ? 'Digite a resposta' : 'Digite uma variação da resposta'}
              value={value}
              onChange={(e) => onChangeHandler(e, index)}
              onBlur={onBlurHandler}
              info={<div className="info">Utilize "$" para referenciar informações coletadas</div>}
            />
          </div>
          <div>

            <Button
              classes="mb-3"
              small
              circle
              onClick={() => onDeleteHandler(index)}
              disabled={index + 1 === text.values.length}
            >
              <span>
                <i className="fa fa-times" aria-hidden="true" />
              </span>
            </Button>

          </div>

        </div>

      ))}
    </>
  );
};

const DialogNodeOutput = (props) => {
  if (props.nonEditable) {
    return (
      <AccordionItem>
        <div>Resposta não disponivel para edição</div>
        <div>
          Essa resposta não pode ser editada no Serprobots Curadoria.
          Acesse a interface do Watson Assistant para alterá-la
        </div>
      </AccordionItem>
    );
  }
  return (
    <AccordionItem
      active={props.justOneOutput || props.output.justBeenCreated}
      actionButtons={(
        <Button
          small
          circle
          classes="delete-response-type"
          title="Apagar resposta"
          onClick={props.removeOutput}
        >
          <i className="fa fa-times" aria-hidden="true" />
        </Button>
      )}
    >
      <div>
        {`${props.output.type}`}
        {' '}

      </div>
      <div>
        {props.output.type === MAP_OUTPUT_FROM_WATSON.TEXT
          ? <DialogNodeOutputText {...props} />
          : <DialogNodeOutputOptionList {...props} />}
      </div>
    </AccordionItem>
  );
};

/** Componente de controle das saidas do dialogo */
const DialogNodeOutputsController = (props) => {
  if (!props.outputs) return <></>;

  const [indexOutputToRemove, setIndexOutputToRemove] = useState(null);

  const moreHandler = (type) => {
    const newOutput = new DialogOutputDTO({ type }, true);
    newOutput.justBeenCreated = true;
    props.setOutputs([...props.outputs, newOutput]);
  };

  const updateOutput = (output, index) => {
    const prevOutput = props.outputs[index];
    if (JSON.stringify(output) === JSON.stringify(prevOutput)) return null;
    const outputs = [...props.outputs];
    outputs[index] = output;
    props.setOutputs(outputs);
    props.save(outputs);
  };

  const removeOutput = (index) => setIndexOutputToRemove(index);

  const removeOutputConfirmation = () => {
    let outputs = [...props.outputs];
    outputs = outputs.filter((o, i) => i !== indexOutputToRemove);
    props.setOutputs(outputs);
    props.save(outputs, () => setIndexOutputToRemove(null));
  };

  const justOneOutput = props.outputs.length === 1;
  return (
    <>
      {indexOutputToRemove !== null && (
        <DeleteConfirmation
          title="Confirmar exclusão"
          content="Deseja prossseguir com a exclusão dessa resposta?"
          confirmationClick={removeOutputConfirmation}
          cancelationClick={() => setIndexOutputToRemove(null)}
        />
      )}
      <div>
        <div className={`${styles.DialogSubList} ${styles.DialogOutputs}`}>
          <Accordion>
            {props.outputs.map((output, index) => (
              <DialogNodeOutput
                justOneOutput={justOneOutput}
                output={output}
                updateOutput={(o) => updateOutput(o, index)}
                removeOutput={() => removeOutput(index)}
              />
            ))}
          </Accordion>

          {props.outputs.length === 0 && (
            <div className={styles.WithoutConditions}>
              Adicione as respostas que serão enviadas por esse nó.
            </div>
          )}

          <div style={{ display: 'inline-block' }}>
            <ContextMenu
              button={(
                <Button
                  small
                  circle
                  primary
                  classes="more-item"
                  onClick={moreHandler}
                  disabled={props.disabled}
                >
                  <i className="fa fa-plus" aria-hidden="true" />
                </Button>
              )}
              options={[MAP_OUTPUT_FROM_WATSON.OPTION, MAP_OUTPUT_FROM_WATSON.TEXT]
                .map((i) => (
                  <a
                    role="button"
                    tabIndex={0}
                    onKeyPress={() => moreHandler(i)}
                    onClick={() => moreHandler(i)}
                  >
                    {i}
                  </a>
                ))}
            />

          </div>
        </div>
      </div>
    </>
  );
};

export default DialogNodeOutputsController;
